import BottomNavbar from '@/components/navbars/bottom-nav/bottom-nav';
import TopNavbar from '@/components/navbars/top-navbar/top-navbar';
import { ShutdownNotification } from '@/components/shutdown-notification/shutdown-notification';
import { useMediaQuery } from '@mui/material';
import { usePathname } from 'next/navigation';
import { ReactNode } from 'react';
import Footer from '../../footer/footer';
import { config } from '@/config/environment';
import ArchiveBanner from '../../archive-banner/archive-banner';
import { Globals } from './components/globals/globals';

export interface PrimaryLayoutProps {
  children: ReactNode;
}

export const PRIMARY_LAYOUT_CONTENT_ID = 'content';

const PrimaryLayout = ({ children }: PrimaryLayoutProps) => {
  const isMobile = useMediaQuery('(max-width:1080px)');
  const pathname = usePathname() || '';
  const currentPath = pathname.split('/')[1]?.split('/')[0];
  return (
    <div>
      <Globals />
      {/* The banner sits at the very top of the page; the sticky navbar follows it and pins to the top once scrolled */}
      {config.platformMode === 'archive' && <ArchiveBanner />}
      <TopNavbar />
      <div id={PRIMARY_LAYOUT_CONTENT_ID}>{children}</div>
      {isMobile ? <Footer /> : currentPath === 'chat' ? null : <Footer />}
      {/*<ShutdownNotification />*/}
    </div>
  );
};

export default PrimaryLayout;
